import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch9_p02 } from "../../../layouts/ch9_p02/ch9_p02";

export class Chapter9Page2 extends AbstractStoryState implements ReturnType<typeof ch9_p02> {
    readonly bg = this.addChild(new SceneSprite());
    readonly hollyContainer = this.addChild(new PIXI.Container());
    readonly holly = list(()=>this.hollyContainer.addChild(new SceneSprite()));

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch9_p02/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch9_p02/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch9_p02.call(this);

        this.holly[0].visible = true;
        this.holly[1].visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();

        TweenLite.delayedCall(1.5, ()=>{
            this.holly[0].FadeOut();
            this.holly[1].FadeIn();
        });

        TweenLite.delayedCall(5, ()=>{
            this.gotoNextState({transition: "left"});
        });
    }
}